export const getRange: (p: { size: number; from: number; step: number }) => ReadonlyArray<number> = ({
  from,
  step,
  size,
}) => [...Array(size)].map((_, i) => from + i * step);
